// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Database Refresh Component Styles */

.database-refresh-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Alert Banner */
.database-refresh .alert {
  padding: 15px 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.database-refresh .alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.database-refresh .alert-error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.database-refresh .alert-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.database-refresh .alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}

.database-refresh .alert-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: inherit;
  padding: 0;
  line-height: 1;
  opacity: 0.7;
}

.database-refresh .alert-close:hover {
  opacity: 1;
}

/* Page Header */
.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  color: #1a1a1a;
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: 600;
}

.page-header .subtitle {
  color: #333333;
  margin: 0;
  font-size: 14px;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
}

.tab-button {
  padding: 12px 24px;
  background: none;
  border: none;
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
}

.tab-button:hover {
  color: #000000;
  background-color: #f8f9fa;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
  font-weight: 600;
}

/* Tab Content */
.tab-content {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Card Styles */
.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.card-header {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header h3 {
  margin: 0;
  font-size: 20px;
  color: #1a1a1a;
  font-weight: 600;
}

.card-header p {
  margin: 5px 0 0 0;
  color: #333333;
  font-size: 13px;
}

.card-body {
  padding: 20px;
}

/* Form Styles */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 14px;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.form-help {
  color: #555555;
  font-size: 12px;
  margin: 5px 0 10px 0;
}

.filter-select {
  width: auto;
  min-width: 200px;
}

/* Database Selection Grid */
.database-selection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.database-checkbox {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.database-checkbox:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.database-checkbox input[type="checkbox"] {
  margin-right: 10px;
  cursor: pointer;
}

.database-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}

.selected-count {
  margin-top: 10px;
  color: #007bff;
  font-size: 13px;
  font-weight: 500;
}

/* Button Styles */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background-color: #218838;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-warning:hover:not(:disabled) {
  background-color: #e0a800;
}

.btn-info {
  background-color: #17a2b8;
  color: white;
}

.btn-info:hover:not(:disabled) {
  background-color: #138496;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 12px;
}

.btn-lg {
  padding: 14px 28px;
  font-size: 16px;
}

/* Badge Styles */
.badge {
  display: inline-block;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  border-radius: 3px;
  text-transform: uppercase;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.badge-oracle {
  background-color: #f80000;
  color: white;
}

.badge-mysql {
  background-color: #00758f;
  color: white;
}

.badge-postgresql {
  background-color: #336791;
  color: white;
}

.badge-sqlserver {
  background-color: #cc2927;
  color: white;
}

.badge-default {
  background-color: #e9ecef;
  color: #495057;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #555555;
}

.empty-state p {
  margin-bottom: 20px;
  font-size: 16px;
}

/* Scheduled Jobs List */
.scheduled-jobs-list {
  display: grid;
  gap: 20px;
}

.scheduled-job-card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  background-color: #f8f9fa;
}

.scheduled-job-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.scheduled-job-header h4 {
  margin: 0;
  font-size: 18px;
  color: #1a1a1a;
  font-weight: 600;
}

.scheduled-job-actions {
  display: flex;
  gap: 8px;
}

.scheduled-job-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.detail-label {
  font-size: 12px;
  color: #555555;
  text-transform: uppercase;
  font-weight: 600;
}

.detail-value {
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 500;
}

/* Active Jobs Card */
.active-jobs-card {
  border-left: 4px solid #007bff;
}

.active-job-item {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 15px;
}

.active-job-item:last-child {
  margin-bottom: 0;
}

.active-job-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.active-job-header h4 {
  margin: 0;
  font-size: 16px;
  color: #1a1a1a;
  font-weight: 600;
}

.progress-info {
  margin-bottom: 15px;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  color: #555555;
}

.progress-bar-container {
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);
  transition: width 0.3s ease;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

.active-job-stats {
  display: flex;
  gap: 20px;
}

.stat-item {
  font-size: 13px;
  color: #1a1a1a;
  font-weight: 500;
}

/* Table Styles */
.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.table thead {
  background-color: #343a40;
}

.table th {
  padding: 12px 10px;
  text-align: left;
  font-weight: 700;
  color: #ffffff;
  font-size: 14px;
  border-bottom: 2px solid #dee2e6;
  background-color: #343a40;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table td {
  padding: 12px 10px;
  border-bottom: 1px solid #e9ecef;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.stat-success {
  color: #28a745;
  font-weight: 600;
}

.stat-failed {
  color: #dc3545;
  font-weight: 600;
}

.stat-warning {
  color: #ffc107;
  font-weight: 600;
}

/* Scoped to DatabaseRefresh only — this is a compact truncated-badge style for
   an inline table cell. It was global, which clipped the full-width error
   BANNERS in the User Access Reports (150px + nowrap + ellipsis = cut off).
   Scoping under .database-refresh keeps it from leaking to other pages. */
.database-refresh .error-message {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
  color: #dc3545;
  font-size: 11px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 98vw;
  max-width: 98vw;
  max-height: 95vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-wide {
  max-width: 1200px;
}

.modal-large {
  max-width: 95vw;
  width: 95%;
  max-height: 95vh;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: #1a1a1a;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #555555;
  padding: 0;
  line-height: 1;
}

.modal-close:hover {
  color: #1a1a1a;
}

.modal-body {
  padding: 15px 20px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Job Details Summary */
.job-details-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
}

.detail-card {
  background-color: #f8f9fa;
  padding: 10px 12px;
  border-radius: 6px;
  text-align: center;
}

.detail-card-label {
  font-size: 10px;
  color: #555555;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 6px;
}

.detail-card-value {
  font-size: 20px;
  color: #1a1a1a;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .database-refresh-container {
    padding: 10px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .tab-navigation {
    overflow-x: auto;
  }

  .tab-button {
    white-space: nowrap;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .database-selection-grid {
    grid-template-columns: 1fr;
  }

  .scheduled-job-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .scheduled-job-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .active-job-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .table {
    font-size: 11px;
  }

  .table th,
  .table td {
    padding: 8px 5px;
  }

  .modal-content {
    width: 95%;
    max-height: 95vh;
  }

  .job-details-summary {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Loading Spinner */
.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DatabaseRefresh.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;0EAG0E;AAC1E;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Database Refresh Component Styles */\n\n.database-refresh-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Alert Banner */\n.database-refresh .alert {\n  padding: 15px 20px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.database-refresh .alert-success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.database-refresh .alert-error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.database-refresh .alert-warning {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.database-refresh .alert-info {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border: 1px solid #bee5eb;\n}\n\n.database-refresh .alert-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: inherit;\n  padding: 0;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n.database-refresh .alert-close:hover {\n  opacity: 1;\n}\n\n/* Page Header */\n.page-header {\n  margin-bottom: 30px;\n}\n\n.page-header h1 {\n  color: #1a1a1a;\n  margin: 0 0 10px 0;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.page-header .subtitle {\n  color: #333333;\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.tab-button {\n  padding: 12px 24px;\n  background: none;\n  border: none;\n  color: #333333;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  transition: all 0.2s;\n}\n\n.tab-button:hover {\n  color: #000000;\n  background-color: #f8f9fa;\n}\n\n.tab-button.active {\n  color: #007bff;\n  border-bottom-color: #007bff;\n  font-weight: 600;\n}\n\n/* Tab Content */\n.tab-content {\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Card Styles */\n.card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.card-header {\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-header h3 {\n  margin: 0;\n  font-size: 20px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.card-header p {\n  margin: 5px 0 0 0;\n  color: #333333;\n  font-size: 13px;\n}\n\n.card-body {\n  padding: 20px;\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1a1a1a;\n  font-size: 14px;\n}\n\n.form-control {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.form-help {\n  color: #555555;\n  font-size: 12px;\n  margin: 5px 0 10px 0;\n}\n\n.filter-select {\n  width: auto;\n  min-width: 200px;\n}\n\n/* Database Selection Grid */\n.database-selection-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  background-color: #f8f9fa;\n}\n\n.database-checkbox {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.database-checkbox:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.database-checkbox input[type=\"checkbox\"] {\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.database-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.selected-count {\n  margin-top: 10px;\n  color: #007bff;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Button Styles */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.btn-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n.btn-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.btn-warning:hover:not(:disabled) {\n  background-color: #e0a800;\n}\n\n.btn-info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.btn-info:hover:not(:disabled) {\n  background-color: #138496;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n.btn-lg {\n  padding: 14px 28px;\n  font-size: 16px;\n}\n\n/* Badge Styles */\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  border-radius: 3px;\n  text-transform: uppercase;\n}\n\n.badge-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.badge-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.badge-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.badge-info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.badge-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.badge-oracle {\n  background-color: #f80000;\n  color: white;\n}\n\n.badge-mysql {\n  background-color: #00758f;\n  color: white;\n}\n\n.badge-postgresql {\n  background-color: #336791;\n  color: white;\n}\n\n.badge-sqlserver {\n  background-color: #cc2927;\n  color: white;\n}\n\n.badge-default {\n  background-color: #e9ecef;\n  color: #495057;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #555555;\n}\n\n.empty-state p {\n  margin-bottom: 20px;\n  font-size: 16px;\n}\n\n/* Scheduled Jobs List */\n.scheduled-jobs-list {\n  display: grid;\n  gap: 20px;\n}\n\n.scheduled-job-card {\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  background-color: #f8f9fa;\n}\n\n.scheduled-job-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.scheduled-job-header h4 {\n  margin: 0;\n  font-size: 18px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.scheduled-job-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.scheduled-job-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.detail-label {\n  font-size: 12px;\n  color: #555555;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.detail-value {\n  font-size: 14px;\n  color: #1a1a1a;\n  font-weight: 500;\n}\n\n/* Active Jobs Card */\n.active-jobs-card {\n  border-left: 4px solid #007bff;\n}\n\n.active-job-item {\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 15px;\n}\n\n.active-job-item:last-child {\n  margin-bottom: 0;\n}\n\n.active-job-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.active-job-header h4 {\n  margin: 0;\n  font-size: 16px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.progress-info {\n  margin-bottom: 15px;\n}\n\n.progress-text {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 13px;\n  color: #555555;\n}\n\n.progress-bar-container {\n  height: 8px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);\n  transition: width 0.3s ease;\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n.active-job-stats {\n  display: flex;\n  gap: 20px;\n}\n\n.stat-item {\n  font-size: 13px;\n  color: #1a1a1a;\n  font-weight: 500;\n}\n\n/* Table Styles */\n.table-responsive {\n  overflow-x: auto;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.table thead {\n  background-color: #343a40;\n}\n\n.table th {\n  padding: 12px 10px;\n  text-align: left;\n  font-weight: 700;\n  color: #ffffff;\n  font-size: 14px;\n  border-bottom: 2px solid #dee2e6;\n  background-color: #343a40;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.table td {\n  padding: 12px 10px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.stat-success {\n  color: #28a745;\n  font-weight: 600;\n}\n\n.stat-failed {\n  color: #dc3545;\n  font-weight: 600;\n}\n\n.stat-warning {\n  color: #ffc107;\n  font-weight: 600;\n}\n\n/* Scoped to DatabaseRefresh only — this is a compact truncated-badge style for\n   an inline table cell. It was global, which clipped the full-width error\n   BANNERS in the User Access Reports (150px + nowrap + ellipsis = cut off).\n   Scoping under .database-refresh keeps it from leaking to other pages. */\n.database-refresh .error-message {\n  display: inline-block;\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: help;\n  color: #dc3545;\n  font-size: 11px;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  width: 98vw;\n  max-width: 98vw;\n  max-height: 95vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-wide {\n  max-width: 1200px;\n}\n\n.modal-large {\n  max-width: 95vw;\n  width: 95%;\n  max-height: 95vh;\n}\n\n.modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #e9ecef;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #555555;\n  padding: 0;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  color: #1a1a1a;\n}\n\n.modal-body {\n  padding: 15px 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n/* Job Details Summary */\n.job-details-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.detail-card {\n  background-color: #f8f9fa;\n  padding: 10px 12px;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.detail-card-label {\n  font-size: 10px;\n  color: #555555;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.detail-card-value {\n  font-size: 20px;\n  color: #1a1a1a;\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .database-refresh-container {\n    padding: 10px;\n  }\n\n  .page-header h1 {\n    font-size: 24px;\n  }\n\n  .tab-navigation {\n    overflow-x: auto;\n  }\n\n  .tab-button {\n    white-space: nowrap;\n  }\n\n  .card-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .database-selection-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .scheduled-job-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .scheduled-job-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .active-job-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .table {\n    font-size: 11px;\n  }\n\n  .table th,\n  .table td {\n    padding: 8px 5px;\n  }\n\n  .modal-content {\n    width: 95%;\n    max-height: 95vh;\n  }\n\n  .job-details-summary {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
